import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_TabPanel, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.TabPanelTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.TabPanelTypeConst.STYLE)),
        class: _normalizeClass(_ctx.getPropertyValue(_ctx.TabPanelTypeConst.CLASS)),
        name: _ctx.getPropertyValue(_ctx.TabPanelTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.TabPanelTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.TabPanelTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.TabPanelTypeConst.PLACEHOLDER),
        header: _ctx.getPropertyValue(_ctx.TabPanelTypeConst.HEADER)
      }, {
        header: _withCtx(() => [
          _renderSlot(_ctx.$slots, "header")
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "header"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.TabPanelTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}